(function () {
  if (window.cantaDiscountCouponsReady) return;
  window.cantaDiscountCouponsReady = true;

  function recommend(root, priceCents) {
    var list = root.querySelector('[data-canta-coupon-list]');
    var viewport = root.querySelector('[data-canta-coupon-viewport]');
    if (!list || !viewport) return;

    var cards = Array.from(list.children).map(function (card) {
      var minimum = Number(card.dataset.cantaCouponMinimumCents);
      return {
        card: card,
        minimum: Number.isFinite(minimum) && minimum > 0 ? minimum : Infinity,
        order: Number(card.dataset.cantaCouponOrder)
      };
    });
    cards.forEach(function (item) {
      item.eligible = Number.isFinite(priceCents) && item.minimum <= priceCents;
    });
    cards.sort(function (a, b) {
      if (a.eligible !== b.eligible) return a.eligible ? -1 : 1;
      var thresholdOrder = a.eligible ? b.minimum - a.minimum : a.minimum - b.minimum;
      return thresholdOrder || a.order - b.order;
    });

    var best = cards.length && cards[0].eligible ? cards[0].card : null;
    cards.forEach(function (item) {
      item.card.classList.toggle('canta-discount-coupons__card--featured', item.card === best);
      list.appendChild(item.card);
    });
    viewport.scrollLeft = 0;
    update(root);
  }

  function update(root) {
    var viewport = root.querySelector('[data-canta-coupon-viewport]');
    var controls = root.querySelector('[data-canta-coupon-controls]');
    var track = root.querySelector('[data-canta-coupon-track]');
    var thumb = root.querySelector('[data-canta-coupon-thumb]');
    if (!viewport || !controls || !track || !thumb) return;

    var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    controls.hidden = maxScroll < 2;
    if (controls.hidden) return;
    var trackWidth = track.clientWidth;
    var thumbWidth = Math.max(18, Math.min(trackWidth, trackWidth * viewport.clientWidth / viewport.scrollWidth));
    thumb.style.width = thumbWidth + 'px';
    var scrollPosition = Math.max(0, Math.min(maxScroll, viewport.scrollLeft));
    if (scrollPosition <= 8) scrollPosition = 0;
    thumb.style.transform = 'translateX(' + ((trackWidth - thumbWidth) * scrollPosition / maxScroll) + 'px)';
    track.setAttribute('aria-valuenow', String(Math.round(100 * scrollPosition / maxScroll)));
    root.querySelector('[data-canta-coupon-prev]').disabled = viewport.scrollLeft <= 8;
    root.querySelector('[data-canta-coupon-next]').disabled = viewport.scrollLeft >= maxScroll - 2;
  }

  function init() {
    document.querySelectorAll('[data-canta-coupon-strip]').forEach(function (root) {
      if (root.dataset.cantaCouponInitialized) return;
      root.dataset.cantaCouponInitialized = 'true';
      var viewport = root.querySelector('[data-canta-coupon-viewport]');
      if (!viewport) return;
      var track = root.querySelector('[data-canta-coupon-track]');
      var thumb = root.querySelector('[data-canta-coupon-thumb]');
      viewport.addEventListener('scroll', function () { update(root); }, { passive: true });
      if (track && thumb) {
        var activePointer = null;
        var dragOffset = 0;
        function scrollToPointer(event) {
          var travel = track.clientWidth - thumb.offsetWidth;
          var maxScroll = viewport.scrollWidth - viewport.clientWidth;
          if (travel <= 0 || maxScroll <= 0) return;
          var x = Math.max(0, Math.min(travel, event.clientX - track.getBoundingClientRect().left - dragOffset));
          viewport.scrollLeft = x <= 1 ? 0 : x >= travel - 1 ? maxScroll : x * maxScroll / travel;
          update(root);
        }
        track.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          var thumbRect = thumb.getBoundingClientRect();
          dragOffset = event.clientX >= thumbRect.left && event.clientX <= thumbRect.right
            ? event.clientX - thumbRect.left
            : thumbRect.width / 2;
          activePointer = event.pointerId;
          track.setAttribute('data-canta-coupon-dragging', '');
          track.setPointerCapture(event.pointerId);
          scrollToPointer(event);
          event.preventDefault();
        });
        track.addEventListener('pointermove', function (event) {
          if (event.pointerId === activePointer) scrollToPointer(event);
        });
        function finishDrag(event) {
          if (event.pointerId !== activePointer) return;
          activePointer = null;
          track.removeAttribute('data-canta-coupon-dragging');
          update(root);
        }
        track.addEventListener('pointerup', finishDrag);
        track.addEventListener('pointercancel', finishDrag);
        track.addEventListener('lostpointercapture', finishDrag);
        track.addEventListener('keydown', function (event) {
          var step = Math.max(168, Math.round(viewport.clientWidth * .2));
          if (event.key === 'ArrowLeft') viewport.scrollBy({ left: -step });
          else if (event.key === 'ArrowRight') viewport.scrollBy({ left: step });
          else if (event.key === 'Home') viewport.scrollLeft = 0;
          else if (event.key === 'End') viewport.scrollLeft = viewport.scrollWidth - viewport.clientWidth;
          else return;
          event.preventDefault();
        });
      }
      var list = root.querySelector('[data-canta-coupon-list]');
      if (list) {
        var listDrag = null;
        list.addEventListener('pointerdown', function (event) {
          if (event.pointerType === 'touch' || event.button !== 0 ||
              event.target.closest('button, a, input, select, textarea')) return;
          listDrag = { id: event.pointerId, x: event.clientX, scrollLeft: viewport.scrollLeft };
          list.setPointerCapture(event.pointerId);
          list.setAttribute('data-canta-coupon-dragging', '');
          event.preventDefault();
        });
        list.addEventListener('pointermove', function (event) {
          if (!listDrag || event.pointerId !== listDrag.id) return;
          viewport.scrollLeft = listDrag.scrollLeft - (event.clientX - listDrag.x);
          update(root);
          event.preventDefault();
        });
        function finishListDrag(event) {
          if (!listDrag || event.pointerId !== listDrag.id) return;
          listDrag = null;
          list.removeAttribute('data-canta-coupon-dragging');
        }
        list.addEventListener('pointerup', finishListDrag);
        list.addEventListener('pointercancel', finishListDrag);
        list.addEventListener('lostpointercapture', finishListDrag);
      }
      recommend(root, Number(root.dataset.cantaCouponPriceCents));
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-canta-coupon-strip]').forEach(update);
  });
  if (document.readyState !== 'loading') init();

  document.addEventListener('variant:change', function (event) {
    var section = event.target && event.target.closest('.shopify-section');
    if (!section || !event.detail || !event.detail.variant) return;
    var priceCents = Number(event.detail.variant.price);
    section.querySelectorAll('[data-canta-coupon-strip]').forEach(function (root) {
      recommend(root, priceCents);
    });
  });

  document.addEventListener('click', async function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var nav = target.closest('[data-canta-coupon-prev], [data-canta-coupon-next]');
    if (nav) {
      var root = nav.closest('[data-canta-coupon-strip]');
      var viewport = root && root.querySelector('[data-canta-coupon-viewport]');
      if (viewport) {
        var direction = nav.hasAttribute('data-canta-coupon-next') ? 1 : -1;
        viewport.scrollBy({ left: direction * Math.max(168, Math.round(viewport.clientWidth * .78)), behavior: 'smooth' });
      }
      return;
    }

    var button = target.closest('[data-canta-coupon-copy]');
    if (!button) return;
    var code = button.getAttribute('data-canta-coupon-copy');
    if (!code) return;
    var feedback = button.querySelector('.canta-discount-coupons__feedback');
    try {
      // Keep the selection-based copy inside the user's click gesture. Theme editor
      // previews can expose navigator.clipboard while denying its write permission.
      var copied = false;
      var field = document.createElement('textarea');
      var previousFocus = document.activeElement;
      field.value = code;
      field.readOnly = true;
      field.style.position = 'fixed';
      field.style.top = '0';
      field.style.left = '0';
      field.style.opacity = '0';
      try {
        document.body.appendChild(field);
        field.focus();
        field.select();
        field.setSelectionRange(0, field.value.length);
        copied = !!document.execCommand('copy');
      } catch (selectionError) {
        copied = false;
      } finally {
        field.remove();
        if (previousFocus && previousFocus.focus) {
          try { previousFocus.focus({ preventScroll: true }); } catch (focusError) { /* Copy can still continue. */ }
        }
      }
      if (!copied) {
        if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Copy failed');
        await navigator.clipboard.writeText(code);
      }
      button.setAttribute('data-copied', 'true');
      if (feedback) feedback.textContent = code + ' copied';
      window.setTimeout(function () {
        button.removeAttribute('data-copied');
        if (feedback) feedback.textContent = '';
      }, 2000);
    } catch (error) {
      if (feedback) feedback.textContent = 'Unable to copy ' + code;
    }
  });
})();
